<template>
    <div class="panel-container">
        <div class="panel-card">
            <div class="calendar-header">
                <div class="header-row">
                    <h3 class="section-title1">无人机AI巡检</h3>
                    <button class="curtain-btn active">
                        + 临时巡检任务
                    </button>
                </div>
            </div>

            <!-- 待执行任务 -->
            <div class="task-card pending">
                <div class="task-header">
                    <div class="status-tag pending">待执行</div>
                    <div class="countdown">执行倒计时: 1天2小时32分31秒</div>
                </div>
                <div class="task-content">
                    <div class="task-info">
                        <div class="info-row">
                            <span class="label">任务编号:</span>
                            <span class="value">20250101001</span>
                        </div>
                        <div class="info-row">
                            <span class="label">执行时间:</span>
                            <span class="value">2025年1月2日 11:30</span>
                        </div>
                        <div class="info-row">
                            <span class="label">机型:</span>
                            <span class="value">机型1</span>
                        </div>
                        <div class="info-row">
                            <span class="label">监护人员:</span>
                            <span class="value">王萌13022223333</span>
                        </div>
                        <div class="info-row">
                            <span class="label">执行路线:</span>
                            <span class="value">路线描述路线描述</span>
                            <span class="preview-link">预览</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 执行中任务 -->
            <div class="task-card executing">
                <div class="task-header">
                    <div class="status-tag executing">执行中</div>
                    <div class="countdown">执行倒计时: <span class="time-highlight">32分31秒</span></div>
                    <button class="action-btn">
                        <i class="icon-rotate"></i>
                        飞行记录
                    </button>
                </div>
                <div class="task-content">
                    <div class="task-info">
                        <div class="info-row">
                            <span class="label">任务编号:</span>
                            <span class="value">20250101001</span>
                        </div>
                        <div class="info-row">
                            <span class="label">执行时间:</span>
                            <span class="value">2025年1月2日 11:30</span>
                        </div>
                        <div class="info-row">
                            <span class="label">机型:</span>
                            <span class="value">机型1</span>
                        </div>
                        <div class="info-row">
                            <span class="label">监护人员:</span>
                            <span class="value">王萌13022223333</span>
                        </div>
                        <div class="info-row">
                            <span class="label">执行路线:</span>
                            <span class="value">路线描述路线描述</span>
                            <span class="preview-link">预览</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 已完成任务 -->
            <div class="task-card completed">
                <div class="task-header">
                    <div class="status-tag completed">已完成</div>
                    <div class="countdown">执行倒计时: <span class="time-highlight">32分31秒</span></div>
                    <button class="action-btn">
                        <i class="icon-rotate"></i>
                        飞行记录
                    </button>
                </div>
                <div class="task-content">
                    <div class="task-info">
                        <div class="info-row">
                            <span class="label">任务编号:</span>
                            <span class="value">20250101001</span>
                        </div>
                        <div class="info-row">
                            <span class="label">执行时间:</span>
                            <span class="value">2025年1月2日 11:30</span>
                        </div>
                        <div class="info-row">
                            <span class="label">机型:</span>
                            <span class="value">机型1</span>
                        </div>
                        <div class="info-row">
                            <span class="label">监护人员:</span>
                            <span class="value">王萌13022223333</span>
                        </div>
                        <div class="info-row">
                            <span class="label">执行路线:</span>
                            <span class="value">路线描述路线描述</span>
                            <span class="preview-link">预览</span>
                        </div>
                    </div>

                    <!-- 执行结果 -->
                    <div class="execution-results">
                        <h4 class="results-title">执行结果</h4>
                        <div class="results-content">
                            <div class="result-item">
                                <span class="label">问题描述:</span>
                                <span class="value">XX植株有坏果</span>
                            </div>
                            <div class="result-item">
                                <span class="label">任务派发:</span>
                                <span class="value">已派发</span>
                            </div>
                            <div class="result-item">
                                <span class="label">当前进度:</span>
                                <span class="value">未处理</span>
                            </div>
                        </div>
                    </div>

                    <!-- AI巡检问题图片 -->
                    <div class="ai-images">
                        <h4 class="images-title">AI巡检问题图片</h4>
                        <div class="image-grid">
                            <div class="image-item">
                                <div class="image-placeholder"></div>
                            </div>
                            <div class="image-item">
                                <div class="image-placeholder"></div>
                            </div>
                            <div class="image-item">
                                <div class="image-placeholder"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TechFarmRightPanel',
    data() {
        return {
            // 可以添加数据
        }
    }
}
</script>

<style lang="less" scoped>
.panel-container {
    height: calc(100vh - 50px - 96px);
    overflow-y: scroll;
}
.panel-card {
    padding: 10px;
    padding-bottom: 3px;
    height: 100%;
}

.section-title1 {
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
    text-shadow: 0px 0px 11px #6CC4FF;
    margin-bottom: 9px;
}

.curtain-btn {
    background: rgba(0, 32, 67, 0.6);
    box-shadow: inset 0px 0px 14px 0px #0691ED;
    border-radius: 4px 4px 4px 4px;
    height: 30px;
    padding: 0 10px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    border: none;
    cursor: pointer;

    &.active {
        background: linear-gradient(270deg, #00A1FF 0%, #006AFF 100%);
        color: #fff;
    }
}

.header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

// 任务卡片样式
.task-card {
    border-radius: 0px;
    overflow: hidden;
    position: relative;
}

.task-header {
    display: flex;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    gap: 15px;
}

.status-tag {
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 32px;
    position: relative;
    width: 83px;
    height: 32px;
    &.pending {
        background: url('../../../../assets/img/stage/btn1.png') no-repeat center center;
        background-size: 100% 100%;
    }

    &.executing {
        background: url('../../../../assets/img/stage/btn2.png') no-repeat center center;
        background-size: 100% 100%;
    }

    &.completed {
        background: url('../../../../assets/img/stage/btn3.png') no-repeat center center;
        background-size: 100% 100%;
    }
}

.countdown {
    color: #fff;
    font-size: 14px;
    flex: 1;

    .time-highlight {
        color: #00A1FF;
        font-weight: 600;
    }
}

.action-btn {
    background: linear-gradient(135deg, #00A1FF, #006AFF);
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 161, 255, 0.4);
    }

    .icon-rotate {
        width: 16px;
        height: 16px;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/></svg>') no-repeat center;
        background-size: contain;
    }
}

.task-content {
    padding: 20px;
}

.task-info {
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.info-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    color: #fff;

    .label {
        width: 80px;
        color: #B0C4DE;
        font-size: 14px;
    }

    .value {
        color: #fff;
        font-size: 14px;
        margin-right: 10px;
        flex: 1;
    }

    .preview-link {
        color: #00A1FF;
        cursor: pointer;
        text-decoration: underline;
        font-size: 14px;

        &:hover {
            color: #006AFF;
        }
    }
}

.execution-results {
    padding: 15px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;

    .results-title {
        color: #fff;
        font-size: 16px;
        margin-bottom: 15px;
        font-weight: 600;
    }

    .results-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        
        .result-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            color: #fff;

            .label {
                width: 80px;
                color: #B0C4DE;
                font-size: 14px;
            }

            .value {
                color: #fff;
                font-size: 14px;
                flex: 1;
            }
        }
    }
}

.ai-images {
    .images-title {
        color: #fff;
        font-size: 16px;
        margin-bottom: 15px;
        font-weight: 600;
    }

    .image-grid {
        display: flex;
        gap: 15px;

        .image-item {
            .image-placeholder {
                width: 80px;
                height: 60px;
                background: linear-gradient(135deg, #2a4a6b, #1a3a5b);
                border-radius: 6px;
                border: 1px solid rgba(255, 255, 255, 0.2);
                position: relative;

                &::after {
                    content: '图片';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #B0C4DE;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>